import apiClient from "../../api/apiClient";

const settingApi = {
  getLicenses: async (params = {}) => {
    const { limit = 10, page = 1, search = '', status = '' } = params;
    const user = JSON.parse(sessionStorage.getItem('user'));
    const itsalesId = user?.itSalesPartner?.id;
    
    const response = await apiClient.get('/partners/itsales-partner/licenses/assigned', {
      params: { limit, page, search, status, itsalesId }
    });
    return response.data;
  },
  
  getTrackUsage: async (params = {}) => {
    const { licenseId, itsalesId, search = '', page = 1, limit = 10 } = params;
    
    const response = await apiClient.get('/partners/itsales-partner/licenses/track-usage', {
      params: { licenseId, itsalesId, search, page, limit }
    });
    return response.data;
  }
};

export { settingApi };